/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_DisclaimerInputs */

const en_landing_footer_disclaimer = /** @type {(inputs: Landing_Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Independent workspace. Not affiliated with or endorsed by Ideogram, Inc.`)
};

const zh_landing_footer_disclaimer = /** @type {(inputs: Landing_Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独立工作台，与 Ideogram, Inc. 无隶属或背书关系。`)
};

/**
* | output |
* | --- |
* | "Independent workspace. Not affiliated with or endorsed by Ideogram, Inc." |
*
* @param {Landing_Footer_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_disclaimer = /** @type {((inputs?: Landing_Footer_DisclaimerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_DisclaimerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_disclaimer(inputs)
	return zh_landing_footer_disclaimer(inputs)
});
export { landing_footer_disclaimer as "landing.footer.disclaimer" }